import { render, staticRenderFns } from "./MenuAppointment.vue?vue&type=template&id=1f1a872f&"
import script from "./MenuAppointment.vue?vue&type=script&lang=js&"
export * from "./MenuAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports